import React from "react";
import { RouteComponentProps } from "react-router-dom";

import { ISessionUser, logout } from "@/data/session";
import { IWithSessionProps, withSession } from "@/infrastructure/Session";
import { PublicLayout } from "@/views/components/Layout";
import { router } from "@/views/router";

interface Props extends IWithSessionProps<ISessionUser>, RouteComponentProps {}

class SessionLogoutComponent extends React.PureComponent<Props> {
  async componentDidMount() {
    const { session } = this.props;

    if (session.authenticated) {
      await logout();
      this.props.session.destroy(() => {
        this.goToLogin();
      });
      return;
    }

    this.goToLogin();
  }

  goToLogin = () => {
    this.props.history.push(router.get("login").path);
  };

  render() {
    return <PublicLayout />;
  }
}

export const SessionLogout = withSession(SessionLogoutComponent);
